<template>


    <div v-bind:class="$store.state.nfr_cur == heistItem.nft.get_id() ? 'mseleitem' : ''">
        <CoalDialogVue></CoalDialogVue>

        <div class="inouter">

            <div style="align-self: flex-start;justify-self: flex-start;">
                <button @click="jump_to_nfr_help()">?</button>
                <button @click="close_heist_item(wrkk)">x</button>
            </div>
            <CoalRend :nft="heistItem.nft" style="margin-bottom: 5%;"></CoalRend>

            <div>
                <span
                    v-show="(heistItem.nft.get_full_owner() == $store.state.wallet_manager.account_name)">strenghtening</span><span
                    v-show="(heistItem.nft.get_full_owner() != $store.state.wallet_manager.account_name)">stealing</span>
                of
                NFT # {{ wrkk }}
            </div>
            <div style="color: red;text-align: center;"
                v-show="(heistItem.nft.get_full_owner() != $store.state.wallet_manager.account_name) && (heistItem.nft.is_in_grace())">
                NFT is in its
                grace period. stealing will fail for one week after minting. grace period remaining :
                {{ heistItem.nft.get_remaining_grace() }} </div>


            <div v-show="heistItem.type == ENUMS.HEIST_TYPE.MANUAL">
                <input type="text" @keyup.enter="check_nonce_strength(wrkk)" class="mytex" v-model="found_nonce"
                    placeholder="input the nonce you found" />
                <button @click="check_nonce_strength(wrkk)">check srength</button>

            </div>
            <div class="smalltex warning " v-show="(nonce_does_not_increase != 0)">nonce does not increase the strength
            </div>
            <div v-show="heistItem.type != ENUMS.HEIST_TYPE.MANUAL">from
                {{ heistItem.nft.get_strength() }} &rarr;
                {{ heistItem.nft.get_strength_with_nonce(heistItem.strongest_nonce_found) }}</div>
            <p class="smalltex myhover" @click="send_to_mine(wrkk)" v-show="heistItem.type == ENUMS.HEIST_TYPE.MANUAL">
                dont
                have
                nonce? send to mine</p>
            <div v-if="(heistItem.type != ENUMS.HEIST_TYPE.MANUAL)"><span class="smalltex fadednonce">
                    ( {{ found_nonce }} ) </span></div>
        </div>

        <div class="nfrholder" v-show="heistItem.type != ENUMS.HEIST_TYPE.MANUAL">
            <div class="nfritem">
                <div>Step 1.</div>
                <div v-show="!step1loading"><button class="" @click="lock_nfr()">
                        <div v-show="!lock_submitted">Lock NFR</div>
                        <div v-show="lock_submitted" style="color: greenyellow;">NFR Sent</div>

                    </button></div>
                <div v-show="step1loading">
                    <LoadingCompVue lwidth="24" lheight="24"></LoadingCompVue>
                </div>
            </div>
            <div class="nfritem">
                <div>Step 2.</div>
                <div><button @click="verify_nfr()">

                        <div v-show="!step2loading">
                            <div v-show="nfr_locked_in_my_name == ENUMS.NFR_STATE.NOT_LOOKED"> Verify NFR</div>
                            <div v-show="nfr_locked_in_my_name == ENUMS.NFR_STATE.NOT_FOUND"> no NFR found. did you skip
                                step 1?</div>

                            <div v-show="nfr_locked_in_my_name == ENUMS.NFR_STATE.LOCKED_IN_OTHER_NAME" class="warning">
                                warning: NFR not locked in your name.
                                do not
                                submit</div>
                            <div v-show="nfr_locked_in_my_name == ENUMS.NFR_STATE.LOCKED_IN_MY_NAME" class="safing"> NFR
                                locked in your name</div>

                        </div>
                        <div v-show="step2loading">
                            <LoadingCompVue lwidth="24" lheight="24"></LoadingCompVue>
                        </div>
                    </button></div>

            </div>
            <div class="nfritem">
                <div>Step 3.</div>
                <div>
                    <button @click="submit_nonce()">
                        <div v-show="!step3loading">Submit Nonce</div>
                        <div v-show="step3loading">
                            <LoadingCompVue lwidth="24" lheight="24"></LoadingCompVue>
                        </div>
                    </button>
                    <div class="smalltex warning"
                        v-show="step3clicked && (nfr_locked_in_my_name != ENUMS.NFR_STATE.LOCKED_IN_MY_NAME)">
                        finish step 2 first
                    </div>

                </div>

            </div>
        </div>

    </div>
</template>

<script>

import ENUMS from '../Enums';
import CoalRend from './CoalRend.vue';
import { SigningError, SubmitNFR, QueryNFR, KeysetFailure, QueryNFRNotFound, get_nft_strength_from_hash, vsetter, get_nft_manager, get_nft_strength_with_nonce, mypolling, get_account } from '@/utility'
import LoadingCompVue from '../LoadingComp.vue';
import CoalDialogVue from './CoalDialog.vue';

export default {
    name: 'CoalHeistItem'
    , data() {
        return {
            ENUMS: ENUMS
            , nfr_locked_in_my_name: ENUMS.NFR_STATE.NOT_LOOKED
            , found_nonce: ""
            , nonce_does_not_increase: 0
            , nonce_does_not_increase_timeout: undefined
            , step3clicked: false
            , step1loading: false
            , step2loading: false
            , step3loading: false
            , lock_submitted: false
            , dialog_message: undefined
        }
    }
    , props: ["heistItem", "wrkk"]
    , computed: {


    }, components: { LoadingCompVue, CoalDialogVue, CoalRend }
    , mounted() {
        if (this.heistItem.strongest_nonce_found != undefined) {
            this.found_nonce = this.heistItem.strongest_nonce_found
        }
    }
    , methods: {
        jump_to_nfr_help() {
            this.$store.commit("changeView", ENUMS.VIEWS.HELP)

            setTimeout(() => {
                document.getElementById("nfr_help_id").scrollIntoView();
            }, 500);

        }
        , close_heist_item(wrkk) {
            this.$store.state.nfr_manager.clean(wrkk)
        }
        , send_to_mine(wrkk) {
            this.$store.state.mine_manager.add_miner(this.$store.state.nfr_manager.nfrs[wrkk].nft)

        }, check_nonce_strength(wrkk) {
            if (this.$store.state.nfr_manager.nfrs[wrkk].nft.get_strength_with_nonce(this.found_nonce) > this.$store.state.nfr_manager.nfrs[wrkk].nft.get_strength()) {
                vsetter(this, ["$store", "state", "nfr_manager", "nfrs", wrkk, "strongest_nonce_found"], this.found_nonce)
                this.$store.state.nfr_manager.nfrs[wrkk].strongest_nonce_found_strength = this.$store.state.nfr_manager.nfrs[wrkk].nft.get_strength_with_nonce(this.found_nonce)
                this.$store.state.nfr_manager.nfrs[wrkk].type = ENUMS.HEIST_TYPE.MINED
                clearTimeout(this.nonce_does_not_increase_timeout)
                this.nonce_does_not_increase = 0
            } else {
                this.nonce_does_not_increase = 1
                var qthis = this
                if (this.nonce_does_not_increase_timeout != undefined) {
                    clearTimeout(this.nonce_does_not_increase_timeout)
                    this.nonce_does_not_increase_timeout = undefined
                }
                this.nonce_does_not_increase_timeout = setTimeout(() => {
                    qthis.nonce_does_not_increase = 0
                }, 1500);
            }
        }
        , lock_nfr() {
            this.nfr_locked_in_my_name = ENUMS.NFR_STATE.NOT_LOOKED
            var qthis = this
            this.step1loading = true

            this.heistItem.lock_nfr()
                .catch(x => {
                    console.log("LOCKCATCH", x)
                    if (x instanceof SigningError) {
                        this.dialog_message = "User rejected signing"
                    }
                    throw x
                })
                .then(x => {
                    console.log("LOCKthn", x)

                })
                .finally(() => { qthis.step1loading = false })

        }
        , verify_nfr() {
            var qthis = this
            this.step2loading = true

            this.heistItem.verify_nfr().catch((x) => {
                console.log("|---------", x)
                if (x instanceof QueryNFRNotFound) {
                    qthis.nfr_locked_in_my_name = ENUMS.NFR_STATE.NOT_FOUND
                    // qthis.dialog_message = "NFR not found, you can Lock the NFR in step 1"
                } else if (x instanceof SigningError) {
                    qthis.dialog_message = "User rejected signing"
                } else if (x instanceof KeysetFailure) {
                    qthis.dialog_message = "NFR does not seem to be locked in your name, it could mean a miner has possibly interfered, it is advised to not continue unless you know what you are doing, report in discord"
                }
                // qthis.step2loading = false
                // // if (x.result == ENUMS.NFR_STATE.NOT_FOUND) {
                // if (x.nfr_not_found()) {
                //     //
                // } else if (x.nfr_stolen()) {

                //     qthis.dialog_message = "NFR is not locked in your name, it could mean a miner has possibly interfering, it is advised to not continue unless you know what you are doing, report in discord"
                // } else {
                //     //
                // }

                throw x
            }).then((x) => {
                if (x instanceof QueryNFR) {
                    qthis.nfr_locked_in_my_name = ENUMS.NFR_STATE.LOCKED_IN_MY_NAME
                }
                qthis.step2loading = false

            }).finally(() => {
                qthis.step2loading = false
            })



        }
        , submit_nonce() {
            var qthis = this

            this.step3clicked = true
            if (qthis.nfr_locked_in_my_name == ENUMS.NFR_STATE.LOCKED_IN_MY_NAME) {
                qthis.step3loading = true

                qthis.heistItem.submit_nonce().catch((x) => {
                    // TODO bad submit
                    if (x instanceof SigningError) {
                        qthis.dialog_message = "User rejected signing"

                    } else {
                        qthis.dialog_message = x

                    }
                    throw x
                }).then((x) => {
                    if (x instanceof SubmitNFR) {
                        qthis.$store.commit("changeView", ENUMS.VIEWS.MYNFTS)
                    } else {
                        qthis.dialog_message = x
                    }
                }).finally(() => {
                    qthis.step3loading = false

                })
            }
        }

        , get_nft_strength_from_hash
        , get_nft_strength_with_nonce
        , mypolling
        , vsetter
        , get_nft_manager
        , get_account
        , QueryNFRNotFound
        , SigningError
        , KeysetFailure
        , QueryNFR
        , SubmitNFR
    }
}

</script>


<style scoped>
.warning {
    color: red;
    animation: warninganim .51s infinite alternate;
}

@keyframes warninganim {
    0% {
        color: red;
    }

    100% {
        color: white;
    }


}

.safing {
    color: greenyellow;
}

.nfrtit {
    margin-top: 3%;
    width: 100%;
    text-align: center;
}

.inouter {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* padding-top: 3%; */
}

.nfrholder {
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-direction: row;
    border-top: solid;
    /* border-color: rgb(255, 255, 255); */
    border-top-color: rgb(110, 110, 110);
    margin-top: 3%;



}

.nfritem {
    /* border-right: solid; */
    padding: 5%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 150px;
}

.nfritem:nth-child(3) {
    border-right: none;
}
</style>